export const RN_IMAGE_MAX_HEIGHT = 480;
export const RN_IMAGE_MIN_WIDTH = 60;

export function parseImageWidth(src: string): {
  cleanSrc: string;
  width: number | null;
} {
  const match = src.match(/#w=(\d+)$/);
  if (!match || match.index === undefined)
    return { cleanSrc: src, width: null };
  return { cleanSrc: src.slice(0, match.index), width: Number(match[1]) };
}

export function withImageWidth(src: string, width: number): string {
  const { cleanSrc } = parseImageWidth(src);
  return `${cleanSrc}#w=${Math.round(width)}`;
}

export function clampImageWidth(
  width: number,
  containerWidth: number,
  naturalWidth: number,
  naturalHeight: number
): number {
  const heightLimitedWidth =
    naturalWidth > 0 && naturalHeight > 0
      ? (RN_IMAGE_MAX_HEIGHT * naturalWidth) / naturalHeight
      : Infinity;
  const max = Math.min(
    containerWidth > 0 ? containerWidth : Infinity,
    naturalWidth > 0 ? naturalWidth : Infinity,
    heightLimitedWidth
  );
  const min = Math.min(RN_IMAGE_MIN_WIDTH, max);
  return Math.round(Math.max(min, Math.min(width, max)));
}
